import { queryOptions } from "@tanstack/react-query"
import type { components } from "@/shared/lib/api.types"
import { apiClient } from "@/shared/lib/apiClient"
import { unwrap } from "@/shared/utils/unwrap"

export type AuthUser = components["schemas"]["AuthUserResponse"]

export const authKeys = {
  me: ["auth", "me"] as const,
}

export const meQueryOptions = queryOptions({
  queryKey: authKeys.me,
  queryFn: () => unwrap(apiClient.GET("/api/auth/me")),
  // Infinity = once per app boot. Never persisted (meta.persist), so every boot
  // revalidates the session against the API instead of trusting localStorage.
  staleTime: Number.POSITIVE_INFINITY,
  retry: false,
  meta: { persist: false },
})
